import { render, staticRenderFns } from "./iframe-login-form.vue?vue&type=template&id=5c66c48a"
import script from "./iframe-login-form.vue?vue&type=script&lang=js"
export * from "./iframe-login-form.vue?vue&type=script&lang=js"
import style0 from "./iframe-login-form.vue?vue&type=style&index=0&id=5c66c48a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports